<script setup lang="ts">
import { useAppInfo } from '../../hooks/useAppInfo';

const appInfo = useAppInfo();
</script>

<template>
  <component :is="appInfo.logoGray" v-if="appInfo" class="app-logo" />
</template>

<style lang="scss" scoped>
@use './AppLogo.scss';
</style>
